module.exports = __webpack_public_path__ + "img/green-coral-02.0c13ef36.png";